<template>
  <v-dialog v-model="inforfrienddialog" persistent max-width="340">
    <v-card v-if="progress">
      <v-layout row wrap align-center justify-center style="height: 250px;">
        <v-progress-circular :size="50" :indeterminate="progress" color="primary"></v-progress-circular>
      </v-layout>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline pa-0">
        <v-spacer></v-spacer>
        <v-btn icon flat color="grey darken-1" @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="justify-content: center; display: flex;">
        <v-layout column align-center justify-center>
          <v-avatar
            size="90px"
            v-if="inforfriend.profilepicture"
          >
          <img :src="inforfriend.profilepicture" class="img-avatar img-border">
          </v-avatar>
          <v-avatar
            size="90px"
            v-else
          >
          <img :src="require('../../assets/robot1.png')" class="img-avatar img-border" v-if="inforfriend.type === 'user'">
          <img :src="require('../../assets/robot1.png')" class="img-avatar img-border" v-else-if="inforfriend.type === 'business'">
          <img :src="require('../../assets/robot1.png')" class="img-avatar img-border" v-else-if="inforfriend.type === 'group'">
          <img :src="require('../../assets/group.png')" class="img-avatar img-border" v-else>
          </v-avatar>
          <v-layout row wrap style="width: 100%;">
            <v-flex xs4>
            </v-flex>
            <v-flex xs4 style="justify-content: center; align-items: center; display: grid;">
              <h3 class="mt-3 text-hidden">{{inforfriend.name}}</h3>
            </v-flex>
            <v-flex xs4>
            </v-flex>
          </v-layout>
          <span class="mt-2" v-if="inforfriend.email">{{inforfriend.email}}</span>
          <span class="mt-2" v-else>-</span>
        </v-layout>
      </v-card-text>
      <!-- <v-divider></v-divider> -->
      <!-- <v-card-actions class="mt-2" v-if="relation !== 'self'">
        <v-flex xs6 sm6 class="flex-center pr-2">
          <v-layout class="cursor-pointer" column align-center justify-center @click="">
            <v-icon class="mb-1 icon-action">{{btnicon}}</v-icon>
              <p style="color: #2562af;" class="mb-0">{{ textbtn }}</p>
          </v-layout>
        </v-flex>
        <v-flex xs6 sm6 class="flex-center pl-2">
          <v-layout class="cursor-pointer" column align-center justify-center @click="viewprofile(inforfriend)">
            <v-icon class="mb-1 icon-action">fas fa-user-circle</v-icon>
              <p style="color: #2562af;" class="mb-0">ดูโปรไฟล์</p>
          </v-layout>
        </v-flex>
      </v-card-actions>
      <v-card-actions class="mt-2" v-else>
        <v-flex xs12 sm12 class="flex-center pr-2">
          <v-layout class="cursor-pointer" column align-center justify-center @click="actionclick(inforfriend)">
            <v-icon class="mb-1 icon-action">{{btnicon}}</v-icon>
              <p style="color: #2562af;" class="mb-0">{{ textbtn }}</p>
          </v-layout>
        </v-flex>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>
<script>
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'
export default {
  props: {
    inforfrienddialog: Boolean,
    tokeninforfriend: String,
    type: String
  },
  data () {
    return {
      textbtn: '',
      tokenuser: '',
      relation: '',
      inforfriend: {},
      btnicon: '',
      tokenroom: '',
      progress: false
    }
  },
  created () {
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
  },
  computed: {
    ...sync('*')
  },
  watch: {
    inforfrienddialog () {
      this.searchfriend()
    },
    socketremove_request_friend (data) {
      this.relation = 'unknown'
      this.textbtn = 'เพิ่มเพื่อน'
      this.btnicon = 'fas fa-user-plus'
    },
    socketaccept_friend (data) {
      // console.log(data)
      this.relation = 'friend'
      this.textbtn = 'แชท'
      this.btnicon = 'fas fa-comment-dots'
    },
    socketfriend (data) {
      // console.log(data)
      if (data.konAdd !== this.tokenuser) {
        this.relation = 'request'
        this.textbtn = 'ยอมรับคำขอ'
        this.btnicon = 'how_to_reg'
      } else {
        this.relation = 'sendrequest'
        this.textbtn = 'ยกเลิกคำขอ'
        this.btnicon = 'person_add_disabled'
      }
    },
    socketremove_friend (data) {
      // console.log(data)
      this.relation = 'unfriend'
      this.textbtn = 'เพิ่มเพื่อน'
      this.btnicon = 'fas fa-user-plus'
    },
    socketblock (data) {
      // console.log(data)
    }
  },
  methods: {
    closeDialog () {
      // this.relation = ''
      // this.inforfriend = {}
      this.$emit('closeInforfriend', false)
    },
    searchfriend () {
      if (this.type !== 'group') {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/searchtokenuser', { tokenuser: this.tokenuser, tokenfriend: this.tokeninforfriend }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.progress = false
            this.relation = response.data.relation
            this.inforfriend = response.data.user
            if (this.relation === 'friend') {
              this.textbtn = 'แชท'
              this.btnicon = 'fas fa-comment-dots'
            } else if (this.relation === 'request') {
              this.textbtn = 'ยอมรับคำขอ'
              this.btnicon = 'how_to_reg'
            } else if (this.relation === 'sendrequest') {
              this.textbtn = 'ยกเลิกคำขอ'
              this.btnicon = 'person_add_disabled'
            } else if (this.relation === 'unknown') {
              this.textbtn = 'เพิ่มเพื่อน'
              this.btnicon = 'fas fa-user-plus'
            } else if (this.relation === 'self') {
              this.textbtn = 'ตกลง'
              this.btnicon = 'fas fa-user-circle'
            } else if (this.relation === 'unfriend') {
              this.textbtn = 'เพิ่มเพื่อน'
              this.btnicon = 'fas fa-user-plus'
            } else if (this.relation === 'block') {
              this.textbtn = 'ยกเลิกการบล็อค'
              this.btnicon = 'fas fa-unlock-alt'
            }
            // console.log(this.inforfriend)
            // console.log(this.relation)
          }
        })
      } else {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/getgroup', {
          tokenuser: this.tokenuser,
          group_id: this.tokeninforfriend
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.inforfriend = response.data.group
            if (response.data.group.state === 'active') {
              this.relation = 'active'
              this.textbtn = 'แชท'
              this.btnicon = 'fas fa-comment-dots'
            } else {
              this.relation = 'leave'
              this.textbtn = 'เข้าร่วมกลุ่ม'
              this.btnicon = 'fas fa-users'
            }
          }
        })
      }
    },
    actionclick (inforfriend) {
      if (this.relation === 'friend') {
        if (inforfriend.tokenroom !== '') {
          this.$router.push('/mobile/room/' + inforfriend.tokenroom)
        } else {
          this.$router.push('/mobile/room/' + this.tokenroom)
        }
        this.closeDialog()
      } else if (this.relation === 'request') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/acceptfriend', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then((response) => {
          if (response.data['status'] === 'success') {
            // console.log(response.data)
            this.tokenroom = response.data.tokenroom
          }
        })
      } else if (this.relation === 'sendrequest') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/removerequestfriend', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then((response) => {
          if (response.data['status'] === 'success') {
            // console.log(response.data)
            this.relation = 'unknown'
            this.textbtn = 'เพิ่มเพื่อน'
            this.btnicon = 'fas fa-user-plus'
            // this.closeDialog()
          }
        })
      } else if (this.relation === 'unknown' || this.relation === 'unfriend') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/addfrienduser', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser }).then((response) => {
          if (response.data['status'] === 'success') {
            // console.log(response.data)
          }
        })
      } else if (this.relation === 'self') {
        this.textbtn = 'ตกลง'
        this.btnicon = 'fas fa-user-circle'
        this.closeDialog()
      } else if (this.relation === 'block') {
        this.$swal({
          text: 'คุณต้องการยกเลิกการบล็อก ' + inforfriend.name + ' ใช่หรือไม่?',
          type: 'warning',
          imageHeight: 70,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-success',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.axios.post(process.env.VUE_APP_API_MANAGE + '/unblockfriend', { tokenfriend: inforfriend.tokenuser, tokenuser: this.tokenuser, tokenroom: inforfriend.tokenroom }).then((response) => {
              if (response.data['status'] === 'success') {
                // console.log(response.data)
                this.$swal(
                  '',
                  'ยกเลิกการบล็อกเพื่อนสำเร็จ.',
                  'success'
                )
                this.relation = 'friend'
                this.textbtn = 'แชท'
                this.btnicon = 'fas fa-comment-dots'
              }
            })
          }
        })
      } else if (this.relation === 'active') {
        // console.log(this.relation)
        this.$router.push('/mobile/room/' + inforfriend.tokenroom)
      } else if (this.relation === 'leave') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/joingroup', {
          group_id: inforfriend.group_id,
          tokenuser: this.tokenuser
        }).then((response) => {
          // console.log(response)
          this.relation = 'active'
          this.textbtn = 'แชท'
          this.btnicon = 'fas fa-comment-dots'
          this.socketactive_group = { timestamp: '', groupid: inforfriend.group_id, tokenuser: this.tokenuser }
          // this.closeDialog()
        })
      }
    },
    viewprofile (inforfriend) {
      // console.log(inforfriend)
      // console.log(inforfriend.tokenuser)
      // localStorage.setItem('tokenfriend', Encode.encodeToken(inforfriend.tokenuser))
      if (inforfriend.type !== 'group') {
        localStorage.setItem('typefriend', inforfriend.type)
        this.$router.push('/mobile/profilefriend/' + inforfriend.tokenuser)
      } else {
        localStorage.setItem('typefriend', inforfriend.type)
        this.$router.push('/mobile/profilefriend/' + inforfriend.group_id)
      }
    }
  }
}
</script>
<style media="screen" scoped>
.bg-toolbar {
  background-color: white;
}
.img-avatar {
  object-fit: cover;
  object-position: 50% 0;
}
.img-border {
  border-style: solid;
  border-color: #d0d0d0;
  border-width: thin;
}
.flex-center {
  justify-content: center;
  display: flex;
}
.btn-action {
  color: rgb(37, 98, 175);
  width: 100%;
}
.btn-profile {
  color: rgb(37, 98, 175);
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
.text-hidden {
  white-space: nowrap;
  /* width: 170px; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon-action {
  color: #2562af !important;
  font-size: 25px !important;
}
</style>
